/*
Topbar menu bold
 */
//$(".WideMenu > li > a").delay(1000).animate({ opacity: 1 }, 700);
$(".WideMenu > li > a").html(function(i,html){
    return html.replace(/^\s*([^\s]+)(\s|$)/, '<span>$1 </span>');
});

$(".WideMenu").css('visibility', 'visible');

jQuery(function($) {
    $(".WideMenu > li > a").attr('href', "javascript:void(0)");
});